export default function pulldown() {

  /* Pull Down 開閉
  ----------------------------------------------------------------- */
  var pullDown = $('.js-pullDown');

  pullDown.on('click', function () {
    if (!$(this).parent().hasClass('is-open')) {
      $(this).parent().addClass('is-open');
    } else {
      $(this).parent().removeClass('is-open');
    }
  });

}